if (!customElements.get('l20-seven-banner')) {
  class L20SevenBanner extends HTMLElement {
    connectedCallback() {
      this.initializeAttempts = 0;
      this.initialize();
    }

    disconnectedCallback() {
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      window.clearTimeout(this.initializeTimer);

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    initialize() {
      if (this.swiper) return;

      if (typeof window.Swiper === 'undefined') {
        if (this.initializeAttempts < 40) {
          this.initializeAttempts += 1;
          this.initializeTimer = window.setTimeout(() => this.initialize(), 50);
        }
        return;
      }

      const slider = this.querySelector('[data-l20-seven-swiper]');
      const previousButton = this.querySelector('[data-l20-seven-previous]');
      const nextButton = this.querySelector('[data-l20-seven-next]');
      const slideCount = Number.parseInt(this.dataset.slideCount, 10) || 0;

      if (!slider || slideCount === 0) return;

      slider.id = `L20SevenSwiper-${this.dataset.sectionId}`;

      const mobileSlides = Number.parseFloat(this.dataset.mobileSlides) || 1.1;
      const desktopSpace = Number.parseInt(this.dataset.desktopSpace, 10) || 40;
      const mobileSpace = Number.parseInt(this.dataset.mobileSpace, 10) || 14;

      this.swiper = new window.Swiper(slider, {
        slidesPerView: mobileSlides,
        spaceBetween: mobileSpace,
        centeredSlides: false,
        initialSlide: 0,
        loop: slideCount > 2,
        rewind: slideCount === 2,
        watchOverflow: true,
        grabCursor: slideCount > 1,
        allowTouchMove: slideCount > 1,
        slideToClickedSlide: slideCount > 1,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        updateOnImagesReady: true,
        speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 500,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation: {
          prevEl: previousButton,
          nextEl: nextButton,
        },
        a11y: {
          enabled: true,
          containerMessage: 'Feature carousel',
          slideLabelMessage: '{{index}} / {{slidesLength}}',
        },
        breakpoints: {
          990: {
            slidesPerView: 'auto',
            spaceBetween: desktopSpace,
            centeredSlides: false,
          },
        },
      });

      this.handleBlockSelect = (event) => {
        const selectedSlide = event.target.closest('.l20-seven-banner__slide');
        if (!selectedSlide || !this.contains(selectedSlide) || !this.swiper) return;

        const slideIndex = Number.parseInt(selectedSlide.dataset.slideIndex, 10);
        if (Number.isNaN(slideIndex)) return;

        if (this.swiper.params.loop) {
          this.swiper.slideToLoop(slideIndex, 0);
        } else {
          this.swiper.slideTo(slideIndex, 0);
        }
      };

      this.addEventListener('shopify:block:select', this.handleBlockSelect);
    }
  }

  customElements.define('l20-seven-banner', L20SevenBanner);
}
